<template>
  <section :class="['header-component', { 'is-mobile': isMobileBreakpoint }]">
    <header class="header-login">
      <LefebvreLogoComponent />
    </header>
  </section>
</template>

<script lang="ts" setup>
import { useVuetify } from '@/composables/useVuetify'
import LefebvreLogoComponent from '@/components/Logo/LefebvreLogoComponent.vue'

// COMPOSABLES
const { isMobileBreakpoint } = useVuetify()
</script>

<style lang="scss" scoped>
.header-component {
  width: 100%;
  height: 64px;
  display: flex;
  padding: $spacing-sm $spacing-xl;
  justify-content: space-between;
  align-items: center;
  background: $neutral-white-000;
  box-shadow: $shadow-md;
  margin-bottom: 4%;

  .header-login {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    background: $neutral-white-000;
  }

  &.is-mobile {
    padding: 10px $spacing-md;
    margin-bottom: $spacing-xxl;
  }
}
</style>
